<button
  class="px-2 me-2"
  kendoButton
  fillMode="solid"
  rounded="large"
  themeColor="primary"
  [title]="
    _clientWO.bulkActionsDisabled()
      ? ('HOME.STREAM.DISABLED_TOOLTIP'
        | translate: { count: (_clientWO.loadedRowCount() | number) })
      : ('HOME_COMPONENTS.MASS_STATUS_UPDATE.STATUS_UPDATE' | translate)
  "
  [fillMode]="!buttonsEnableState() ? 'outline' : 'solid'"
  [disabled]="!buttonsEnableState() || _clientWO.bulkActionsDisabled()"
  (click)="showMassStatusUpdate()"
  >
  <fa-icon [icon]="faGears" class="w-px-20 me-1"></fa-icon>
  {{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.STATUS_UPDATE' | translate }}
</button>
@if (showStatusPopup) {
  <kendo-dialog [height]="660" [width]="800" (close)="closeForm()">
    <kendo-dialog-titlebar class="title centerlabel">{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.TITLE' | translate }}</kendo-dialog-titlebar>
    <div class="p-3">
      <div class="text-primary text-center fw-bold mt-2 mb-4">{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.WORKORDER_AFFECTED' | translate }}: {{selectedWorkOrders().length}}</div>
      <div class="text-center mb-2">{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.CONFIRM_UPDATE_STATUS' | translate }}</div>
      <div class="mb-3">
        <div>{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.WORKORDER_STATUS' | translate }}:<span class="required">*</span></div>
        <kendo-combobox
          [data]="collection2"
          textField="item_name"
          [placeholder]="'HOME_COMPONENTS.MASS_STATUS_UPDATE.SELECT_STATUS' | translate"
          valueField="id"
          #collection_id2
          required
          [value]="woStatus"
          [valuePrimitive]="true"
          (valueChange)="listValueChange2($event)">
        </kendo-combobox>
      </div>
      <div class="mb-3">
        <div>{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.SKIP_CODE' | translate }}:@if (woStatusName != 'Completed') {
          <span class="required">*</span>
        }</div>
        <kendo-combobox
          [data]="collection1"
          textField="item_name"
          [placeholder]="'HOME_COMPONENTS.MASS_STATUS_UPDATE.SELECT_SKIP_CODE' | translate"
          valueField="item_name"
          #collection_id1
          [value]="skipCode"
          [valuePrimitive]="true"
          (valueChange)="listValueChange1($event)">
        </kendo-combobox>
      </div>
      <div class="mb-3">
        <kendo-label [text]="woAdmin?.comment_title"><span class="required">*</span>
        <kendo-textarea
          [placeholder]="'HOME_COMPONENTS.MASS_STATUS_UPDATE.ENTER_COMMENT' | translate"
          [(ngModel)]="comment"
          [rows]="5"
          resizable="none"
        ></kendo-textarea>
      </kendo-label>
    </div>
    <div class="mb-3">
      <div>{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.SET_CURRENT_TASK' | translate }}:</div>
      <kendo-combobox
        [data]="taskList"
        textField="title"
        [placeholder]="'HOME_COMPONENTS.MASS_STATUS_UPDATE.SELECT_TASK' | translate"
        valueField="name"
        #task_list
        [value]="taskToCreate"
        [valuePrimitive]="true"
        (valueChange)="tasklistValueChange($event)">
      </kendo-combobox>
    </div>
  </div>
  <kendo-dialog-actions [layout]="'end'">
    <button kendoButton
      look="outline"
      [themeColor]="'base'"
      (click)="closeForm()">
      <fa-icon [icon]="faTimes" class="w-px-20 me-1"></fa-icon>
      {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
    </button>
    <button kendoButton
      [themeColor]="'primary'"
      (click)="confirm()"
      class="ms-1"
      [disabled]="comment == '' || (woStatusName != 'Completed' && skipCode == '') || woStatus == null">
      <fa-icon [icon]="faFloppyDisk" class="w-px-20 me-1"></fa-icon>
      {{ 'HOME_COMPONENTS.COMMON.SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}
@if (showWarning) {
  <kendo-dialog [height]="260" [width]="450" (close)="confirmCancel()">
    <kendo-dialog-titlebar class="title centerlabel">{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.CONFIRM_SAVE' | translate }}</kendo-dialog-titlebar>
    <div class="p-3">
      <div class="text-center mb-2">{{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.TYPE_OVERRIDE' | translate }}</div>
      <div class="text-center mb-3 mt-3">
        <kendo-textarea
          [(ngModel)]="confirmText"
          [rows]="1"
          resizable="none"
          (valueChange)="onConfirmTextChange($event)"
        ></kendo-textarea>
      </div>
    </div>
    <kendo-dialog-actions [layout]="'end'">
      <button kendoButton
        look="outline"
        [themeColor]="'primary'"
        (click)="confirmCancel()"
        [disabled]="isSubmit">
        <fa-icon [icon]="faTimes" class="w-px-20 me-1"></fa-icon>
        {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
      </button>
      <button kendoButton
        [themeColor]="'primary'"
        (click)="save()"
        class="ms-1"
        [disabled]="confirmText !== 'OVERRIDE' || isSubmit"
        >
        <fa-icon [icon]="faFloppyDisk" class="w-px-20 me-1"></fa-icon>
        {{ 'HOME_COMPONENTS.MASS_STATUS_UPDATE.CONFIRM_SAVE' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
